module.exports = __webpack_public_path__ + "resources/img/img_awesome_secure_trust2_en.e4fffe34e8675156252e97c90a8e4294.png";